module.exports = __webpack_public_path__ + "img/113.209797fb.png";